import React from 'react';
import { ResponsiveFunnel } from '@nivo/funnel';
import { corPorIndice, SUPERFICIE } from './paletaResultados';

// Múltipla escolha com 2-3 itens — funil em vez de pizza/rosca de propósito:
// múltipla escolha não é mutuamente exclusiva (a soma pode passar de 100%
// dos respondentes), então uma forma de "parte-do-todo" passaria a
// impressão errada. O funil só ordena por magnitude, sem prometer que as
// fatias somam o total.
const GraficoFunil = ({ itens, totalRespostas }) => {
  if (!itens || itens.length === 0) {
    return <p className="text-sm text-gray-400 italic py-6 text-center">Nenhum dado registrado ainda.</p>;
  }

  const ordenados = [...itens].sort((a, b) => b.votos - a.votos);
  const dados = ordenados.map((item) => ({ id: item.slug, label: item.label, value: item.votos || 0.001 }));
  // Array na mesma ordem dos dados — {index} não funciona de forma
  // confiável em todo gráfico Nivo (ver GraficoPizza.js/GraficoBolhas.js);
  // array é o jeito garantido de mapear cor por posição.
  const cores = dados.map((_, indice) => corPorIndice(indice));

  return (
    <div style={{ height: 260 }}>
      <ResponsiveFunnel
        data={dados}
        margin={{ top: 12, right: 24, bottom: 12, left: 24 }}
        direction="horizontal"
        interpolation="smooth"
        shapeBlending={0.6}
        spacing={4}
        colors={cores}
        borderWidth={2}
        borderColor={SUPERFICIE}
        enableLabel
        labelColor={{ from: 'color', modifiers: [['darker', 2.6]] }}
        beforeSeparatorLength={0}
        afterSeparatorLength={0}
        currentPartSizeExtension={4}
        animate
        motionConfig="gentle"
        role="img"
        ariaLabel="Gráfico de funil com o total de votos por opção"
        tooltip={({ part }) => (
          <div className="bg-white shadow-lg rounded-lg pl-2.5 pr-3.5 py-2 border border-gray-100 flex items-stretch gap-2.5">
            <span className="w-[3px] rounded-full flex-shrink-0" style={{ backgroundColor: part.color }} />
            <div>
              <p className="text-base font-semibold text-gray-900 leading-tight">
                {Math.round(part.data.value).toLocaleString('pt-BR')} <span className="text-xs font-normal text-gray-400">voto(s)</span>
              </p>
              <p className="text-xs text-gray-500">
                {part.data.label} · {totalRespostas > 0 ? Math.round((part.data.value / totalRespostas) * 1000) / 10 : 0}% dos respondentes
              </p>
            </div>
          </div>
        )}
      />
    </div>
  );
};

export default GraficoFunil;
